export class RecolteEspeceQuantite {
    static jsonMap = {
        idEspece: { key: 'idEspece' },
        codeEspece: { key: 'codeEspece', optional: true, default: '' },
        idEntreprise: { key: 'idEntreprise', optional: true },
        quantite: { key: 'quantite', optional: true }
    };

    idEspece: number;
    codeEspece: string;
    idEntreprise: number;
    quantite: number;
}
